import { cva, VariantProps } from "class-variance-authority";

export const inputVariants = cva(
  "tw-h-40 tw-px-12 tw-py-8 focus:tw-outline focus:tw-outline-2 focus:tw-outline-blue-800 focus:tw-outline-offset-1 tw-border-gray-400 focus:tw-border-gray-900 tw-border tw-rounded-4 tw-inline-block tw-text-gray-900 placeholder:tw-text-gray-600 disabled:tw-text-gray-500 disabled:placeholder:tw-text-gray-500 tw-bg-base-white [appearance:textfield] [&::-webkit-outer-spin-button]:tw-appearance-none [&::-webkit-inner-spin-button]:tw-appearance-none",
  {
    variants: {
      fullWidth: {
        true: "tw-w-full",
        false: "",
      },
      error: {
        true: "tw-border-red-800 focus:tw-border-red-800",
        false: "",
      },
      prefix: {
        true: "",
        false: "",
      },
      suffix: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      {
        prefix: true,
        class: "tw-pl-40 tw-pr-12",
      },
      {
        suffix: true,
        class: "tw-pr-40 tw-pl-12",
      },
      {
        suffix: true,
        prefix: true,
        class: "tw-pl-40 tw-pr-40",
      },
    ],
  },
);

export type InputVariantProps = VariantProps<typeof inputVariants>;
